/**
 * Created by Ricardo Sansores on 2017-06-24.
 * "Customer" service
 *
 * This consumes Customer REST Api
 *
 *
 */
import { serializeParams } from '../common/helpers';
import request from './request';

export const get = (url = '', params = {}) => {
    return request().get(`${url}${serializeParams(params)}`)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            //TODO Hay que hacer un buen manejo de errores. Por ahora simplemente regresamos test data pero se debe borrar y en caso de error en el webservice propagarlo a la vista de alguna forma para que se maneje posteriormente.
            return testData;
            //return error;
        });
};

export const post = (url = '', params = {}) => {
    return request().post(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const put = (url = '', params = {}) => {
    return request().put(url, params)
        .then(response => {
            return response.data;
        })
        .catch(error => {
            return error;
        });
};

export const Delete = (url = '', params = {}) => {
    return request().delete(url, params)
        .then(response => {
            return { message: "La Aduana fue eliminada correctamente", color: '#04B404'};
        })
        .catch(error => {
            return { message: error.response.data.message, color: '#ce3b3b'};
        });
};

var testData = {
    "_embedded": {
        "customsHouses": [{
            "name": "CIUDAD JUAREZ, CIUDAD JUAREZ, CHIHUAHUA.",
            "customsNumber": "07",
            "section": "0",
            "_links": {
                "self": {
                    "href": "http://localhost:8080/afs/v1/customsHouses/4b5d4720-c247-49ae-be3f-ed4d6bab474b"
                },
                "customsHouse": {
                    "href": "http://localhost:8080/afs/v1/customsHouses/4b5d4720-c247-49ae-be3f-ed4d6bab474b"
                }
            }
        }
        ]
    }
}



// WEBPACK FOOTER //
// ./services/customsHouses.js